








































































import { Vue, Component, Prop } from "vue-property-decorator";
import { AttivitaIstituto } from "../../_models/attivitaIstituto";

@Component
export default class DetailsAttivita extends Vue {
  @Prop() info!: AttivitaIstituto;
  private dataProtocollazione: string;
  constructor() {
    super();
    this.dataProtocollazione = "";
  }
  created() {
    if (this.info.dataProtocollazione !== "1/1/1970") {
      this.dataProtocollazione = this.info.dataProtocollazione;
    }
  }
}
